import { render } from "./VtoHeaderCounter.vue?vue&type=template&id=86396026"
import script from "./VtoHeaderCounter.vue?vue&type=script&lang=js"
export * from "./VtoHeaderCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__